const Nav = {
    content: null,
    icon: null,
    init: () => {
        Nav.content = document.querySelector("#nav");
        Nav.icon = document.querySelector("#nav-icon");
        Nav.bind();
    },
    bind: () => {
        Nav.icon.addEventListener("click", (e) => {
            if (!Nav.content.classList.contains("active")) {
                console.log(" Nav.content.classList.add('active');")
                Nav.content.classList.add("active");
            } else {
                Nav.content.classList.remove("active");
                console.log(" Nav.content.classList.remove('active');")
            }
        });

        window.onscroll = function(ev) {
            if ((window.scrollY) >= 200) {
                Nav.icon.classList.add("active");
            } else {
                Nav.icon.classList.remove("active");
            }
        };


        // window.onload = function() {
        //     var target = document.getElementById("div5");
        //     animate(document.scrollingElement || document.documentElement, "scrollTop", "", 0, target.offsetTop, 2000, true);
        // };


        // let url = window.location.protocol + "//" + window.location.host + "/" + window.location.pathname + window.location.search
        let val = Nav.getQueryVariable('category');
        if (val != false) {
            var target = document.getElementById(val);
            setTimeout(function() {
                Nav.animate(document.scrollingElement || document.documentElement, "scrollTop", "", 0, target.offsetTop, 10, true);
            }, 100);
        }
    },
    getQueryVariable: (variable) => {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) { return pair[1]; }
        }
        return (false);
    },
    animate: (elem, style, unit, from, to, time, prop) => {
        if (!elem) {
            return;
        }
        var start = new Date().getTime(),
            timer = setInterval(function() {
                var step = Math.min(1, (new Date().getTime() - start) / time);
                if (prop) {
                    elem[style] = (from + step * (to - from)) + unit;
                } else {
                    elem.style[style] = (from + step * (to - from)) + unit;
                }
                if (step === 1) {
                    clearInterval(timer);
                }
            }, 25);
        if (prop) {
            elem[style] = from + unit;
        } else {
            elem.style[style] = from + unit;
        }
    }

}

export default Nav;